/**
 * The typed client for the `/v1` API.
 *
 * `schema.ts` is generated from core-api's OpenAPI document by `pnpm api:client`; nothing here is
 * written by hand, so the client cannot drift from the API. Applications wrap this with their own
 * base URL, authentication, and error mapping rather than calling it directly.
 */
import createClient, { type ClientOptions } from 'openapi-fetch';
import type { paths } from './schema.js';

export type { Middleware } from 'openapi-fetch';
export type { components, operations, paths } from './schema.js';

/** A client bound to one deployment's API. */
export type ApiClient = ReturnType<typeof createApiClient>;

export function createApiClient(options: ClientOptions): ReturnType<typeof createClient<paths>> {
  return createClient<paths>(options);
}

/** The error body every non-2xx response carries (conventions: error taxonomy). */
export interface ErrorEnvelope {
  code: string;
  message: string;
  details?: unknown;
  correlationId: string;
}

export function isErrorEnvelope(value: unknown): value is ErrorEnvelope {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as ErrorEnvelope).code === 'string' &&
    typeof (value as ErrorEnvelope).correlationId === 'string'
  );
}
